var _path, _line, _path2, _line2, _line3, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.091,3.669h13.46c2.572,0,4.661,2.088,4.661,4.661v30.002H3.431V8.329c0-2.572,2.088-4.661,4.661-4.661Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.988,
    y1: 15.067,
    x2: 25.278,
    y2: 15.067
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.212,15.067h4.612c4.275,0,7.745,3.47,7.745,7.745v15.52h-12.357V15.067h0Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.988,
    y1: 22.442,
    x2: 25.278,
    y2: 22.442
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 32.161,
    y1: 22.442,
    x2: 37.91,
    y2: 22.442
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 13.988,
    y1: 29.817,
    x2: 25.278,
    y2: 29.817
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 32.161,
    y1: 29.817,
    x2: 38.569,
    y2: 29.817
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorBuilding);
export default __webpack_public_path__ + "static/media/indoor-building.61149c77f34eaf70ee8e8010cc744a25.svg";
export { ForwardRef as ReactComponent };